module.exports = __webpack_public_path__ + "img/9788964372500.771ed507.jpg";